module.exports = __webpack_public_path__ + "static/media/riskpic4@2x.21a8520e.png";